// Recovered compiled webpack factory 1150. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function () {
        return l;
      },
    }));
  let n = r(95155),
    a = r(12115),
    o = r(24437);
  function i(e) {
    return { default: e && "default" in e ? e.default : e };
  }
  r(36552);
  let s = { loader: () => Promise.resolve(i(() => null)), loading: null, ssr: !0 },
    l = function (e) {
      let t = { ...s, ...e },
        r = (0, a.lazy)(() => t.loader().then(i)),
        l = t.loading;
      function u(e) {
        let i = l ? (0, n.jsx)(l, { isLoading: !0, pastDelay: !0, error: null }) : null,
          s = !t.ssr || !!t.loading,
          u = s ? a.Suspense : a.Fragment,
          c = t.ssr
            ? (0, n.jsxs)(n.Fragment, { children: [null, (0, n.jsx)(r, { ...e })] })
            : (0, n.jsx)(o.BailoutToCSR, {
                reason: "next/dynamic",
                children: (0, n.jsx)(r, { ...e }),
              });
        return (0, n.jsx)(u, { ...(s ? { fallback: i } : {}), children: c });
      }
      return ((u.displayName = "LoadableComponent"), u);
    };
}
